import { request } from "@/http";

export const getTransactions = (page?: number, perPage?: number, transactionType?: string, currencyTypeId?: number) => {
    const queryParams = new URLSearchParams({
        ...(page && { page: page.toString() }),
        ...(perPage && { perPage: perPage.toString() }),
        ...(transactionType && { transactionType }),
        ...(currencyTypeId && { currencyTypeId: currencyTypeId.toString() })
    });

    return request({
        url: `transactions/customer/view?${queryParams.toString()}&sortType=desc`,
        method: 'GET'
    })
}

export const getTransactionProgress = ({ transactionId }: { transactionId: string | number }) => {

    return request({
        url: `transactions/${transactionId}/stages/progress`,
        method: 'GET'
    })
}
